import { render, staticRenderFns } from "./MyModal.vue?vue&type=template&id=bf7fec3a&scoped=true"
import script from "./MyModal.vue?vue&type=script&lang=js"
export * from "./MyModal.vue?vue&type=script&lang=js"
import style0 from "./MyModal.vue?vue&type=style&index=0&id=bf7fec3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7fec3a",
  null
  
)

export default component.exports